export default "__VITE_ASSET__f0fa5272__"